import { NgModule, Optional, SkipSelf } from "@angular/core";

import { throwIfAlreadyLoaded } from "../module-import-guard";
import { Api } from './api';
import { AuthLocalService } from './auth-local.service';
import { LoadingService } from './loading.service';
import { MenuService } from './menu.service';
import { SearchUtilsService } from './search-utils.service';
import { ToastService } from './toast.service';

@NgModule({
  providers: [
    Api,
    AuthLocalService,
    LoadingService,
    MenuService,
    SearchUtilsService,
    ToastService
  ]
})
export class UtilModule {
  constructor(@Optional() @SkipSelf() parentModule: UtilModule) {
    throwIfAlreadyLoaded(parentModule, 'UtilModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/util.module.ts